module.exports = __webpack_public_path__ + "img/guideline.ae6a493.svg";